var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.2f196fe80d2a12bc7ad215f0dd721c9b.svg#B';
                    var viewUrl = 'sprites.2f196fe80d2a12bc7ad215f0dd721c9b.svg#view-B';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 25',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };